import React, { createContext, useContext, useState, ReactNode } from "react";
import { ProjectModule } from "../types";

interface ProjectContextType {
  projectDetails: ProjectModule | null;
  setProjectDetails: (project: ProjectModule | null) => void;
}

const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

interface ProjectProviderProps {
  children: ReactNode;
}

export const ProjectProvider: React.FC<ProjectProviderProps> = ({ children }) => {
  const [projectDetails, setProjectDetails] = useState<ProjectModule | null>(null);

  return (
    <ProjectContext.Provider value={{ projectDetails, setProjectDetails }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjectContext = () => {
  const context = useContext(ProjectContext);
  if (context === undefined) {
    throw new Error("useProjectContext must be used within a ProjectProvider");
  }
  return context;
}; 